import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from '@geekbears/ngx-gb-ui-kit';

@Component({
  selector: 'app-reminder-modals',
  templateUrl: './reminder-modals.modal.html',
  styleUrls: ['./reminder-modals.modal.scss'],
})
export class ReminderModals extends ModalComponent implements OnInit {
  dontAskAgain: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<ReminderModals>
  ) {
    super();
  }

  ngOnInit(): void {}
  closeModal() {
    if (this.dontAskAgain) localStorage.setItem('_dontAskAgain', 'true');

    this.dialogRef.close();
  }
}
